module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scholarship-page"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (!_vm.loading) ? _c('div', [_c('div', {
    staticClass: "scholarship-page__wrap"
  }, [(_vm.props.image_group.image_url) ? _c('img', {
    staticClass: "scholarship-page__image",
    attrs: {
      "src": _vm.props.image_group.image_url,
      "alt": ""
    }
  }) : _vm._e(), _c('div', {
    staticClass: "scholarship-page__btnwrap"
  }, [(_vm.props.btn_group.btn_text) ? _c('a', {
    staticClass: "scholarship-page__btn",
    attrs: {
      "href": _vm.props.btn_group.btn_url,
      "target": "_blank"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.btn_group.btn_text)
    }
  }) : _vm._e()])]), _c('FooterMain')], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59e86044","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/gene-l-reese-scholarship-endowment/gene-l-reese-scholarship-endowment.pug
// module id = 639
// module chunks = 1